import React from 'react';
import { Heading4, Body } from '~/components/atom/Typography';
import Input from '~/components/molecule/Input';
import { TEXT } from '../../constants';
import SectionContainer from '../SectionContainer';
import type {
  UpdateSettingsAction,
  UpdateSettingsState,
} from '../../reducers/settingsReducer';
import type { TouchedFields } from '../../hooks/useSettingsValidation';

type Props = {
  updateSettings: UpdateSettingsState;
  phoneNumberErrors: Array<string>;
  setFieldTouched: (field: keyof TouchedFields) => void;
  dispatch: React.Dispatch<UpdateSettingsAction>;
};

const CallbackPhoneNumberSection: React.FCC<Props> = ({
  updateSettings,
  phoneNumberErrors,
  setFieldTouched,
  dispatch,
}) => (
  <SectionContainer>
    <Heading4 size="m">{TEXT.callbackPhoneNumberHeader}</Heading4>
    <Body size="base" color={{ group: 'text', variant: 'light' }}>
      {TEXT.callbackPhoneNumberDescription}
    </Body>
    <Input
      label={{ text: TEXT.phoneNumber }}
      type="text"
      value={updateSettings?.callbackPhoneNumber ?? ''}
      onChange={e => {
        setFieldTouched('phoneNumber');
        dispatch({
          type: 'SET_CALLBACK_PHONE_NUMBER',
          payload: e.target.value,
        });
      }}
      externalErrors={phoneNumberErrors}
      width="100%"
      placeholder="+31612345678"
    />
  </SectionContainer>
);

export default CallbackPhoneNumberSection;
